module.exports = __webpack_public_path__ + "static/media/whats.4b8d0231.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/whats.png
// module id = 1685
// module chunks = 0